export const GET_FEEDBACKS = "GET_FEEDBACKS";
export const FILTER_FEEDBACKS = "FILTER_FEEDBACKS";
export const ADD_FEEDBACK = "ADD_FEEDBACK";
export const EDIT_FEEDBACK = "EDIT_FEEDBACK";
export const GET_FEEDBACK = "GET_FEEDBACK";
export const RESET_FEEDBACK = "RESET_FEEDBACK";
export const FEEDBACKS_ERROR = "FEEDBACKS_ERROR";
